import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import NoteList from "./note-list"
import NoteSideMenu from "./note-side-menu"

export const NoteLists = ({
  needCaseStudie = true,
  needColumns = true,
  needCultures = true,
  needOverWrite = false,
  overWriteData = '',
  overWriteType = ''
}) => {
  const data = useStaticQuery (
    graphql`
    query NoteQuery {
      caseStudies: allMicrocmsNotes(
        limit: 2
        sort: {fields: [publishedAt], order: DESC}
        filter: {large_category: {eq: "事例集"}}
      ) {
        edges {
          node {
            notesId
            title
            large_category
            middle_category {
              id
              name
              display_color
            }
            thumbnail {
              url
            }
            tags {
              id
              name
              type
            }
          }
        }
      }


      columns: allMicrocmsNotes(
        limit: 2
        sort: {fields: [publishedAt], order: DESC}
        filter: {large_category: {eq: "自由研究"}}
      ) {
        edges {
          node {
            notesId
            title
            large_category
            middle_category {
              id
              name
              display_color
            }
            thumbnail {
              url
            }
            tags {
              id
              name
              type
            }
          }
        }
      }

      cultures: allMicrocmsNotes(
        limit: 2
        sort: {fields: [publishedAt], order: DESC}
        filter: {large_category: {eq: "職場日記"}}
      ) {
        edges {
          node {
            notesId
            title
            large_category
            middle_category {
              id
              name
              display_color
            }
            thumbnail {
              url
            }
            tags {
              id
              name
              type
            }
          }
        }
      }
    }`
  )

  if(needOverWrite) {
    switch(overWriteType) {
      case "caseStudy":
        data.caseStudies.edges = overWriteData
        break
      case "column":
        data.columns.edges = overWriteData
        break
      case "culture":
        data.cultures.edges = overWriteData
        break
      default:
        overWriteData = ''
    }
  }

  return (
    <>
    <div className="contents contents_wrap">
      <div className="contents_in">
        <div className="padding_sp">{/* スマホのみ隙間 */}

          <div className="contents_in_l">

          { needCaseStudie && Object.keys(data.caseStudies.edges).length ?
            <>
              <div className="flex_ttl clearfix">
                <div className="note_title case_study">
                  <div className="note_title_in">
                    <p className="title_en"><span>Case Study</span></p>
                    <h4 className="maintitle" id="case_study_ttl"><span>イキイキ・ワクワク事例集</span></h4>
                    <p className="subtitle"><span>お客様の生の声とともに、具体的な事例を紹介します</span></p>
                  </div>
                </div>
                <div className="read_more"><Link to="/note/case-study"></Link></div>
              </div>

              <NoteList data={data.caseStudies.edges} />

              <div className="view_more_container case-study sp_only">
                <Link to="/note/case-study" className="c_red">もっと見る</Link>
              </div>

            </>
            : ''
          }

          { needColumns && Object.keys(data.columns.edges).length ?
            <>
              <div className="flex_ttl clearfix">
                <div className="note_title column">
                  <div className="note_title_in">
                    <p className="title_en"><span>Research</span></p>
                    <h4 className="maintitle" id="column_ttl"><span>ジェイフィールの自由研究</span></h4>
                    <p className="subtitle"><span>メンバーの興味・関心をお伝えします</span></p>
                  </div>
                </div>
                <div className="read_more"><Link to="/note/column"></Link></div>
              </div>

              <NoteList data={data.columns.edges} />

              <div className="view_more_container sp_only">
                <Link to="/note/column" className="c_blue">もっと見る</Link>
              </div>

            </>
            : ''
          }

          { needCultures && Object.keys(data.cultures.edges).length ?
            <>
              <div className="flex_ttl clearfix">
                <div className="note_title culture">
                  <div className="note_title_in">
                    <p className="title_en"><span>Culture</span></p>
                    <h4 className="maintitle" id="culture_ttl"><span>ご機嫌な職場日記</span></h4>
                    <p className="subtitle"><span>ジェイフィールコミュニティの魅力を届けるルポ</span></p>
                  </div>
                </div>
                <div className="read_more"><Link to="/note/culture"></Link></div>
              </div>

              <NoteList data={data.cultures.edges} />

              <div className="view_more_container sp_only">
                <Link to="/note/culture" className="c_green">もっと見る</Link>
              </div>

            </>
            : ''
          }
        </div>{/* contents_in_l */}

        <NoteSideMenu />

        </div>{/* padding_sp スマホのみ隙間 */}
      </div>{/* contents_in */}
    </div>{/* /contents */}
    </>
  )
}

export default NoteLists
